import { render, staticRenderFns } from "./Fahrdienst452.vue?vue&type=template&id=2afa5999&"
import script from "./Fahrdienst452.vue?vue&type=script&lang=js&"
export * from "./Fahrdienst452.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports